'use client';

import { MoviePosterComponent } from '@/components/movie-poster/movie-poster';
import { useTrailerShowtimes } from '@/hooks/showtimes/trailer-showtimes';
import { useTheaterContext } from '@/hooks/state/theater';
import { MovieCatalogItem } from '@/types/movie-catalog';
import { getTodayInTimeZone } from '@/utils/date-time-helper';
import { useState } from 'react';

type MoviesListGridItemProps = {
  dataLinkCategory: string;
  index: number;
  movie: MovieCatalogItem;
  tabLabel: string;
  zipCode?: string;
};

export const MoviesListGridItem = ({ dataLinkCategory, index, movie, tabLabel, zipCode }: MoviesListGridItemProps): React.JSX.Element => {
  const [isTrailerOpen, setIsTrailerOpen] = useState(false);
  const { data: theater } = useTheaterContext();
  const {
    hasActiveShowtimes,
    isShowtimesLoading,
    showtimes,
    theaterId,
    theaterName,
    timeZone,
  } = useTrailerShowtimes({
    date: theater?.timeZone ? getTodayInTimeZone(theater.timeZone) : undefined,
    enabled: isTrailerOpen,
    movieId: movie.cinemarkMovieId,
    preferredTheaterId: theater?.theaterId,
    zipCode,
  });
  const movieWithTheater = {
    ...movie,
    theaterId: theaterId ?? movie.theaterId,
    theaterName: theaterName ?? movie.theaterName,
  };

  return (
    <MoviePosterComponent showAdvanceTickets
      showPlayButton
      showTitle
      dataLinkCategory={dataLinkCategory}
      dataLinkName={`${tabLabel} Poster ${index + 1}`}
      hasActiveShowtimes={hasActiveShowtimes}
      isShowtimesLoading={isShowtimesLoading}
      movie={movieWithTheater}
      posterClassName="w-full md:w-full max-w-[256px] justify-self-center"
      showtimes={showtimes}
      theaterName={theaterName}
      timeZone={timeZone}
      titleDataLinkName={`Movie Title ${index + 1}`}
      trailerDataLinkName={`Trailer Click ${index + 1}`}
      onTrailerOpenChange={setIsTrailerOpen}
    />
  );
};
